import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CaptchaService } from 'src/app/core/services/captch-service/captcha.service';
import { loginTryBroadcastService } from 'src/app/core/services/logintry.service';

@Component({
  selector: 'app-captcha-check',
  templateUrl: './captcha-check.component.html',
  styleUrls: ['./captcha-check.component.scss']
})
export class CaptchaCheckComponent implements OnInit {
  // @Input() loggedIn: EventEmitter<boolean>;
  @Output() captchaVerified = new EventEmitter<void>();

  @Input("config") config: any = {};
  @Output() captchaCode = new EventEmitter();
  @Output() closeSecurityModalref: EventEmitter<any> = new EventEmitter();
  captch_input:any = null;
  code: any = null;
  resultCode:any = null;
  captchaCheckError:any = "";
  verifiedCheck:Boolean = false;
  constructor(
    private captchService:CaptchaService,
    private loginTryService: loginTryBroadcastService
    ){}
  ngOnInit(): void {
    // this.loggedIn.subscribe(loggedIn => {
    //   if (loggedIn && this.verifiedCheck) {
    //     this.onSubmit();
    //   }
    // });
    this.closeSecurityModalref.emit(this.verifiedCheck);
    this.loginTryService.currentApprovalStageMessage.subscribe(msg => {
      if (msg === "failed") {
        this.setCaptchaUnverified()
      }
    });
    if (this.config) {
      if (!this.config.font || !this.config.font.size) {
        this.config["font"]["size"] = "40px";
      }
      if (!this.config.font || !this.config.font.family) {
        this.config["font"]["family"] = "Finger Paint, cursive";
      }
      if (!this.config.strokeColor) {
        this.config["strokeColor"] = "#f20c6c";
      }
      if (!this.config.length) {
        this.config["length"] = 5;
      }
      if (!this.config.cssClass) {
        this.config["cssClass"] = '';
      }

      if (!this.config.type) {
        this.config["type"] = 3;
      }

      if (!this.config.back || !this.config.back.stroke) {
        this.config["back"]["stroke"] = "";
      }
      if (!this.config.back || !this.config.back.solid) {
        this.config["back"]["solid"] = "#f2efd2";
      }

      this.createCaptcha();
    }
  }
  ngOnChanges() {

  }
  createCaptcha() {
    this.closeSecurityModalref.emit(false);
    this.captchaCheckError = ""
    this.captch_input = ''
    switch(this.config.type) {
      case 1: // only alpha numaric degits to type

      let char =
      Math.random()
        .toString(24)
        .substring(2, this.config.length) +
      Math.random()
        .toString(24)
        .substring(2, 4);
      this.code = this.resultCode = char.toUpperCase();
      break;
      case 2: // solve the calculation
      let num1 = Math.floor(Math.random() * 99);
      let num2 = Math.floor(Math.random() * 9);
      let operators = ['+','-'];
      let operator = operators[(Math.floor(Math.random() * operators.length))];
      this.code =  num1+operator+num2+'=?';
      this.resultCode = (operator == '+')? (num1+num2):(num1-num2);
      break;
    }


    setTimeout(() => {
      let captcahCanvas: any = document.getElementById("captcahCanvas");
      // Error Handling
      if (!captcahCanvas) {
        console.error("Canvas element not found.");
        return;
      }

      var ctx = captcahCanvas?.getContext("2d");
      if (!ctx) {
        console.error("Failed to get canvas context.");
        return;
      }
      ctx.fillStyle = this.config.back.solid;
      //ctx.fillStyle = 'transparent';
      ctx.fillRect(0, 0, captcahCanvas.width, captcahCanvas.height);

      ctx.beginPath();

      captcahCanvas.style.letterSpacing = 10 + "px";
      ctx.font = this.config.font.size + " " + this.config.font.family;
      ctx.fillStyle = this.config.font.color;
      ctx.textBaseline = "middle center";
      ctx.fillText(this.code, 50, 45);
      if (this.config.back.stroke) {
        ctx.strokeStyle = this.config.back.stroke;
        for (var i = 0; i < 150; i++) {
          ctx.moveTo(Math.random() * 300, Math.random() * 300);
          ctx.lineTo(Math.random() * 300, Math.random() * 300);
        }
        ctx.stroke();
      }

      // this.captchaCode.emit(char);
    }, 100);
  }

  playCaptcha() {
    var msg = new SpeechSynthesisUtterance(this.code.split('').join(' '));
    msg.pitch = 0.1;
    window.speechSynthesis.speak(msg);
  }

  checkCaptcha() {
    if (this.captch_input != this.resultCode) {
      this.captchService.setCaptchaStatus(false);
      this.captchaCheckError = "Please enter the right code!"
      this.closeSecurityModalref.emit(this.verifiedCheck);
    } else  {
      this.captchaCheckError = ""
      this.verifiedCheck = true
      this.captchService.setCaptchaStatus(true);
      this.closeSecurityModalref.emit(this.verifiedCheck)
      this.captchaVerified.emit();
    }
  }
  closeSecurityCheckModal() {
    this.closeSecurityModalref.emit(this.verifiedCheck)
  }
  setCaptchaUnverified() {
    this.createCaptcha();
    this.verifiedCheck = false
  }

}
